<script setup>
import {computed} from "vue";
import {useTicketStore} from "../../../store/tickets.js";
import {useModalStore} from "../../../store/modal.js";

const store = useTicketStore()
const modalStore = useModalStore()

const params = computed(() => modalStore.props.params)
const isAdmin = computed(() => modalStore.props.isAdmin ?? false)
const filterData = computed(() => store.filter_data)

const apply = () => {
    modalStore.props.onApply?.()
    modalStore.close()
}

const clear = () => {
    modalStore.props.onClear?.()
}
</script>

<template>
    <div class="modal">
        <div class="modal-header">
            <h2>Filters.</h2>

            <button @click="modalStore.close()">
                <ah-icon name="cross-default" />
            </button>
        </div>

        <div class="modal-body">
            <brand-form-select
                variant="sidebar"
                label="Sorting."
                :options="filterData?.sorting ?? []"
                v-model="params.sort_direction"
            />

            <brand-form-select
                v-if="isAdmin"
                variant="sidebar"
                label="Assignee."
                :options="filterData?.assignees ?? []"
                v-model="params.assignee_id"
            />

            <brand-form-select
                variant="sidebar"
                label="Status."
                :options="filterData?.statuses ?? []"
                v-model="params.status"
            />

            <brand-form-select
                variant="sidebar"
                label="Assignment."
                :options="filterData?.assignment ?? []"
                v-model="params.assignment"
            />

            <brand-form-select
                variant="sidebar"
                label="Linkage."
                :options="filterData?.linkage ?? []"
                v-model="params.linkage"
            />

            <div class="date-header">
                <h3>Date</h3>

                <button @click="params.start_date = null; params.end_date = null">
                    Clear
                </button>
            </div>

            <brand-form-input
                label="Start date."
                variant="date"
                v-model="params.start_date"
            />

            <brand-form-input
                label="End date."
                variant="date"
                v-model="params.end_date"
            />
        </div>

        <div class="modal-footer">
            <brand-button
                as="button"
                variant="small"
                @click="clear"
            >
                Clear
            </brand-button>

            <brand-button
                as="button"
                variant="primary"
                @click="apply"
            >
                Apply
            </brand-button>
        </div>
    </div>
</template>
